<script setup lang="ts">
import { computed, toRef } from 'vue';
import { useEventStore } from '@/stores/event/event.store';
import Tr from '@/i18n/translation';
import { useStateStore } from '@/stores/state.store';

const eventStore = useEventStore();
const stateStore = useStateStore();

defineProps({
  pageNumber: {
    type: Number,
    required: true,
  },
  header: {
    type: String,
    required: true,
  },
  buttonText: {
    type: String,
    required: true,
  },
  subheading: {
    type: String,
    required: true,
  },
});

const mainColor = toRef(() => stateStore.getColors.mainColor);
const buttonColor = toRef(() => stateStore.getColors.buttonColor);
const backgroundColor = toRef(() => stateStore.getColors.backgroundColor);
const textFont =
  eventStore.getCommonData.textFont &&
  eventStore.getCommonData.textFont.trim() !== ''
    ? eventStore.getCommonData.textFont
    : 'Petit Formal Script';

const btnColor = computed(() => {
  return buttonColor.value ? buttonColor.value : mainColor.value;
});
</script>

<template>
  <div class="page">
    <h2 class="core-default-h2 custom-font">{{ header }}</h2>
    <div class="send">
      <component
        :is="stateStore.isAllButtonsDisabled ? 'span' : 'router-link'"
        class="button"
        :to="
          Tr.i18nRoute({ name: 'AdditionalPage', params: { page: pageNumber } })
        "
        >{{ buttonText }}</component
      >
      <p>{{ subheading }}</p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.page {
  position: relative;
  margin: auto;
  margin-bottom: 40px;
  width: 70%;
  display: flex;
  flex-direction: column;
  gap: 28px;
  text-align: center;

  @media screen and (max-width: 500px) {
    margin-bottom: 25px;
    gap: 10px;
  }

  p,
  b {
    margin: 0;
    text-transform: uppercase;
  }

  .send {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    color: v-bind(btnColor);

    @media screen and (max-width: 500px) {
      gap: 7px;
    }

    .button {
      width: auto;
      border-radius: 48.707px;
      border: 2px solid v-bind(btnColor);
      padding: 15px 25px;
      font-size: 25px;
      font-weight: 400;
      white-space: wrap;
      text-align: center;
      text-transform: uppercase;
      transition: background-color 1s ease;

      &:hover {
        background-color: v-bind(btnColor);
        color: v-bind(backgroundColor);
      }

      @media screen and (max-width: 500px) {
        font-size: 18px;
        line-height: 30px;
        padding: 10px 20px;
      }
    }

    p {
      font-size: 0.85em;
    }
  }
}

.custom-font {
  font-family: v-bind(textFont), 'Petit Formal Script', serif;
}
</style>
